import React, { Component } from "react";
import OntripMap from "./onTripMap.js";
import CompletedMap from "./completedMap.js";
import AssignedMap from "./assignedMap.js";
import PreTripMap from "./preTripMap.js";
import CancelledMap from "./cancelledBookingMap.js";

const TRACKING_ACTIVE_BEFORE = 4 * 60 * 60 * 1000;

// import moment from "moment";

// import styles from "./map.module.scss";

class CustomerTrack extends Component {
  // Moengage.track_event("Invoke Chat", {
  //   "mobile" : "",
  //  });

  // Before the bus starts its trip the map is anchored on the boarding point.
  // A broken GPS feed only falls back to the artwork once the tracking link
  // has actually gone live — until then there is nothing to report.
  getPreTripMap = () => {
    const { booking, TrackingWorking } = this.props;

    const trackingLinkActive =
      Date.now() >= booking.boardingPoint.time - TRACKING_ACTIVE_BEFORE;

    if (trackingLinkActive && !TrackingWorking) {
      return <AssignedMap booking={booking} />;
    }

    return <PreTripMap booking={booking} />;
  };

  getComponentToRender = () => {
    const {
      booking,
      tripStatus,
      updateJourneyDetails,
      wayPoints,
      updateETA,
      checkLastTime,
      TrackingWorking,
      upcomingStation,
      isStationMarked,
      station,
      updateUpcomingStation
    } = this.props;
    if (booking.status == "CONFIRMED") {
      if (upcomingStation) {
        switch (tripStatus) {
          case "ONTRIP": {
            return (
              <OntripMap
                isStationMarked={isStationMarked}
                tripId={booking.tripId}
                lastPoint={this.props.lastlocation}
                isTrackingWorking={TrackingWorking}
                fromstation={booking.boardingPoint.address}
                dropPoint={booking.dropPoint.address}
                station={station}
                mapCenter={
                  booking.isOnboarded
                    ? this.props.lastlocation
                    : booking.boardingPoint
                }
                booking={booking}
                isOnboarded={booking.isOnboarded}
                path={wayPoints}
                updateJourneyDetails={updateJourneyDetails}
                checkLastTime={checkLastTime}
                updateETA={updateETA}
                onPassengerBoarded={this.props.onPassengerBoarded}
                upcomingStation={upcomingStation}
                updateUpcomingStation={updateUpcomingStation}
              />
            );
          }

          case "ACTIVE": {
            //bus is not attached
            return this.getPreTripMap();
          }

          case "ASSIGNED": {
            return this.getPreTripMap();
          }

          case "COMPLETED": {
            return <CompletedMap booking={booking} />;
          }

          default: {
            return null;
          }
        }
      } else {
        return tripStatus === "COMPLETED" ? (
          <CompletedMap booking={booking} />
        ) : (
          this.getPreTripMap()
        );
      }
    } else {
      return <CancelledMap />;
    }
  };

  render() {
    return <>{this.getComponentToRender()}</>;
  }
}

export default CustomerTrack;
